import { graphql } from "@/lib/gql/__generated__";

export const MagazineAnalyticsSetting_DesignPage_Query = graphql(`
	query MagazineAnalyticsSetting_DesignPage($hotelID: ID!) {
		magazineAnalyticsSetting(hotelID: $hotelID) {
			id
			hotelID
			gtmAvailable
			gtmID
			pixelAvailable
			pixelID
		}
		guestPageVisibilitySettings(hotelID: $hotelID) {
			id
			hotelID
			plainVisibility
			magazineVisibility
			snackVisibility
		}
	}
`);
